import * as React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { Wrapper } from './tabbed-header.styled';

// #region styles
const SkeletonWrapper = styled(Wrapper)`
  padding: 0.5rem;
  & > * {
    margin-inline-end: 1rem;
  }
`;

const SkeletonContainer = styled.div`
  align-items: stretch;
  box-shadow: 0 1px 1px 0 #0000001a;
  background-color: ${Styles.color.white};
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  justify-content: center;
  height: 111px;

  padding-block-start: 0;
  padding-block-end: 0;
  padding-inline-start: 1rem;
  padding-inline-end: 1rem;

  position: sticky;
  inset-block-start: 0;
  z-index: ${Styles.zIndex.overlay};
`;
// #endregion

interface NewTabSkeletonProps {
  numberOfSkeletonItems?: number;
}

export const TabbedHeaderSkeleton = () => {
  return (
    <SkeletonWrapper>
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
      <Skeleton height="95%" width="5rem" />
    </SkeletonWrapper>
  );
};

export const NewTabSkeleton: React.FC<NewTabSkeletonProps> = ({ numberOfSkeletonItems = 7 }) => {
  return (
    <SkeletonContainer>
      {Array.from({ length: numberOfSkeletonItems }).map((_, index) => (
        <Skeleton key={index} height="100px" width="11rem" />
      ))}
    </SkeletonContainer>
  );
};
